// frontend/src/site/editor/migrateConteudo.js

function isObj(v) {
  return v && typeof v === 'object' && !Array.isArray(v);
}
function asObj(v) {
  return isObj(v) ? v : {};
}
function asArr(v) {
  return Array.isArray(v) ? v : [];
}

function pickFirstNonEmpty(...vals) {
  for (const v of vals) {
    if (v === undefined || v === null) continue;
    if (typeof v === 'string' && v.trim() === '') continue;
    return v;
  }
  return '';
}

function mergeKeepDefault(defaults, incoming) {
  const d = asObj(defaults);
  const i = asObj(incoming);
  const out = { ...d, ...i };

  for (const k of Object.keys(d)) {
    const dv = d[k];
    const iv = i[k];

    if (isObj(dv) && isObj(iv)) out[k] = mergeKeepDefault(dv, iv);
    if (Array.isArray(dv)) out[k] = Array.isArray(iv) ? iv : dv;
  }
  return out;
}

export function migrateConteudo({
  fromModelId,
  toModelId,
  conteudoAtual,
  defaultsByModel,
}) {
  const from = String(fromModelId || 'corretor');
  const to = String(toModelId || 'corretor');

  const DEFAULT_TO =
    defaultsByModel?.[to]?.conteudo ||
    defaultsByModel?.corretor?.conteudo ||
    {};

  const current = asObj(conteudoAtual);

  // base: defaults do destino + conteúdo atual (mantém campos comuns)
  let next = mergeKeepDefault(DEFAULT_TO, current);

  if (from === 'corretor' && to === 'imobiliaria') {
    const im = asObj(current.imoveis);
    const d = asObj(current.destaques);

    next.destaques = {
      ...asObj(next.destaques),
      ...d,
      titulo: pickFirstNonEmpty(d.titulo, im.titulo, next.destaques?.titulo),
      subtitulo: pickFirstNonEmpty(
        d.subtitulo,
        im.subtitulo,
        next.destaques?.subtitulo
      ),
      modo: pickFirstNonEmpty(d.modo, im.modo, next.destaques?.modo),
      quantidade: Number(
        pickFirstNonEmpty(
          d.quantidade,
          im.quantidade,
          next.destaques?.quantidade
        )
      ),
      ids: asArr(pickFirstNonEmpty(d.ids, im.ids, next.destaques?.ids)),
      mostrarBotaoVerTodos:
        d.mostrarBotaoVerTodos ??
        im.mostrarBotaoVerTodos ??
        next.destaques?.mostrarBotaoVerTodos,
      textoBotaoVerTodos: pickFirstNonEmpty(
        d.textoBotaoVerTodos,
        im.textoBotaoVerTodos,
        next.destaques?.textoBotaoVerTodos
      ),
    };

    // evita confusão no renderer
    delete next.imoveis;
  }

  if (from === 'imobiliaria' && to === 'corretor') {
    const d = asObj(current.destaques);
    const im = asObj(current.imoveis);

    next.imoveis = {
      ...asObj(next.imoveis),
      ...im,
      titulo: pickFirstNonEmpty(im.titulo, d.titulo, next.imoveis?.titulo),
      subtitulo: pickFirstNonEmpty(
        im.subtitulo,
        d.subtitulo,
        next.imoveis?.subtitulo
      ),
      modo: pickFirstNonEmpty(im.modo, d.modo, next.imoveis?.modo),
      quantidade: Number(
        pickFirstNonEmpty(im.quantidade, d.quantidade, next.imoveis?.quantidade)
      ),
      ids: asArr(pickFirstNonEmpty(im.ids, d.ids, next.imoveis?.ids)),
      mostrarBotaoVerTodos:
        im.mostrarBotaoVerTodos ??
        d.mostrarBotaoVerTodos ??
        next.imoveis?.mostrarBotaoVerTodos,
      textoBotaoVerTodos: pickFirstNonEmpty(
        im.textoBotaoVerTodos,
        d.textoBotaoVerTodos,
        next.imoveis?.textoBotaoVerTodos
      ),
    };

    delete next.destaques;
    delete next.terrenos; // não existe no corretor padrão
  }

  // preserva blocos sempre presentes
  next.hero = {
    ...asObj(DEFAULT_TO.hero),
    ...asObj(current.hero),
    ...asObj(next.hero),
  };
  next.ctaFinal = {
    ...asObj(DEFAULT_TO.ctaFinal),
    ...asObj(current.ctaFinal),
    ...asObj(next.ctaFinal),
  };
  next.rodape = {
    ...asObj(DEFAULT_TO.rodape),
    ...asObj(current.rodape),
    ...asObj(next.rodape),
  };

  return next;
}
